import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=e87d5ace&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=e87d5ace&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e87d5ace",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e87d5ace')) {
      api.createRecord('e87d5ace', component.options)
    } else {
      api.reload('e87d5ace', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=e87d5ace&scoped=true&", function () {
      api.rerender('e87d5ace', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2bopLGgPRloRQ/JS/comp/GuestBox.vue"
export default component.exports